import { Navigate, useParams } from 'react-router-dom';

/**
 * HAT-1231: «משתמשים והרשאות» (/:fundId/fund-settings/users) no longer has a screen of its own -
 * the coordinators, the representatives and their permissions are sections of «הגדרות». Anyone who
 * kept the address, or was sent it, lands there.
 */
const FundSettingsRedirect = () => {
  const { fundId } = useParams();

  return <Navigate to={`/${fundId}/fund-settings/info`} replace />;
};

export default FundSettingsRedirect;
